import UniversalChart from './universal-chart';
export default UniversalChart;
